import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Formik, Form, Field } from 'formik';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import * as Yup from 'yup';
import { intlShape } from '../../../../../components/prop-types';
import { validationMessages } from '../../../../../i18n/common';
import Debug from '../../../../../components/Debug';
import FormikTextCopiable from '../../../../../components/formik-components/FormikTextCopiable';
import { LegacyInputTextComponent } from '../../../../../components/prime-formik';


const buildValidationSchema = formatMessage => (Yup.object().shape({
  confirmation_code: Yup
    .string()
    .required(formatMessage(validationMessages.required)),
  re_confirmation_code: Yup
    .string()
    .oneOf([Yup.ref('confirmation_code'), null], validationMessages.sameAs)
    .required(formatMessage(validationMessages.required)),
  requestForDeletionDateChecked: Yup.boolean(),
  requestForDeletionOn: Yup.date().nullable(),
}));

const i18n = defineMessages({
  header: { id: 'del_header.jps.spec', defaultMessage: 'Delete Job Profile Survey' },
  cancel: { id: 'actions.cancel', defaultMessage: 'Cancel' },
  delete: { id: 'actions.delete', defaultMessage: 'Delete' },
  confirmWarning: { id: 'lbl.del_confirm.warning', defaultMessage: 'This action cannot be undone.' },
  confirmationCode: { id: 'lbl.confirmation_code', defaultMessage: 'Confirmation code' },
  confirmationCodeRetype: { id: 'lbl.confirmation_code_retype', defaultMessage: 'Please type the confirmation code' },
  deletionRequest: { id: 'lbl.deletion.request', defaultMessage: 'Anonymized 90 days after the request made on: ' },
});

class JPSDeleteConfirmModal extends Component {
  render() {
    const {
      cancelDelete,
      confirmDelete,
      isVisible,
      intl: { formatMessage },
      selectedJPS,
    } = this.props;
    const initialValues = {
      confirmation_code: selectedJPS || '',
      re_confirmation_code: '',
    };
    const validationSchema = buildValidationSchema(formatMessage);
    const dialogFooter = (
      <Fragment>
        <Button
          className="p-button-primary"
          label={formatMessage(i18n.cancel)}
          type="button"
          onClick={cancelDelete}
        />
        &nbsp;
        <Button
          className="p-button-danger"
          label={formatMessage(i18n.delete)}
          type="submit"
        />
        <Debug />
      </Fragment>
    );
    return (
      <Formik
        onSubmit={confirmDelete}
        validationSchema={validationSchema}
        initialValues={initialValues}
        enableReinitialize
        render={({ handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <Dialog
              header={formatMessage(i18n.header)}
              footer={dialogFooter}
              visible={isVisible}
              onHide={cancelDelete}
              modal
            >
              <div className="panel panel-no-border">
                <div className="panel-body">
                  <div className="p-grid p-fluid">
                    <div className="p-col-12">
                      <p>
                        <strong>
                          {formatMessage(i18n.confirmWarning)}
                        </strong>
                      </p>
                    </div>
                    <div className="p-col-12">
                      {formatMessage(i18n.confirmationCode)}
                      <Field
                        name="confirmation_code"
                        keyValue={selectedJPS}
                        component={FormikTextCopiable}
                        readOnly
                      />
                    </div>
                    <div className="p-col-12">
                      {formatMessage(i18n.confirmationCodeRetype)}
                      <div>
                        <Field
                          name="re_confirmation_code"
                          component={LegacyInputTextComponent}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Dialog>
          </Form>
        )}
      />
    );
  }
}

JPSDeleteConfirmModal.propTypes = {
  cancelDelete: PropTypes.func.isRequired,
  confirmDelete: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
  selectedJPS: PropTypes.string,
  intl: intlShape.isRequired,
};

JPSDeleteConfirmModal.defaultProps = {
  selectedJPS: null,
};

export default injectIntl(JPSDeleteConfirmModal);
